import React from 'react';

import { ReactSVG } from 'react-svg';
import facebookIcon from '@ergeon/icons/svg/social-facebook.svg';
import instagramIcon from '@ergeon/icons/svg/social-instagram.svg';
import mediumIcon from '@ergeon/icons/svg/social-medium.svg';

import { SocialLinksProps } from './types';

const SOCIAL_LINKS = [
  {
    name: 'Facebook',
    href: 'https://www.facebook.com/eraborhood',
    icon: facebookIcon,
  },
  {
    name: 'Instagram',
    href: 'https://www.instagram.com/ergeon/',
    icon: instagramIcon,
  },
  {
    name: 'Medium',
    href: 'https://medium.com/@ergeon',
    icon: mediumIcon,
  },
];

const SocialLinks: React.FC<SocialLinksProps> = ({ className = '' }) => {
  return (
    <div className={`flex items-center gap-4 ${className}`}>
      {SOCIAL_LINKS.map((social) => (
        <a
          aria-label={social.name}
          className="text-gray-400 hover:text-gray-600"
          href={social.href}
          key={social.name}
          rel="noopener noreferrer"
          target="_blank">
          <ReactSVG className="size-6" src={social.icon} />
        </a>
      ))}
    </div>
  );
};

export default SocialLinks;
